/**
 * Default pipeline stage copy seeded by the backend on job creation
 * (`JobService.create_job`). Keep in sync with `arbi-app/backend/app/services/job_service.py`.
 */
export const DEFAULT_SOURCED_STAGE_DESCRIPTION =
  "This stage is for all talent profiles sourced from talent search. This stage is a system requirement and cannot be removed or modified.";

export const DEFAULT_INBOX_STAGE_DESCRIPTION =
  "Profiles that have been advanced from sourcing and are ready for review. You can rename, edit, or remove this stage.";

export const DEFAULT_ARCHIVED_STAGE_DESCRIPTION =
  "This stage is for all talent profiles that have been archived. This stage is a system requirement and cannot be removed or modified.";

export function getDefaultStageDescription(name: string): string {
  switch (name.trim().toLowerCase()) {
    case "sourced":
      return DEFAULT_SOURCED_STAGE_DESCRIPTION;
    case "inbox":
      return DEFAULT_INBOX_STAGE_DESCRIPTION;
    case "archived":
      return DEFAULT_ARCHIVED_STAGE_DESCRIPTION;
    default:
      return "";
  }
}
